import { createSlice } from '@reduxjs/toolkit';
import { ErrorType, RootState } from '../../../app/store';
import { OwnerDocumentDto, OwnerDocumentSearchResponseDto, PropertyDTO } from '@inosio/payments-sdk';

interface OwnerDocumentsDataPage {
  Rows: Array<OwnerDocumentDto>;
}

type DocumentsState = {
  Properties: Array<PropertyDTO>;
  isFetchingPropertiesFailed: Boolean;
  isFetchingProperties: Boolean;
  isFetchingPropertiesSuccess: Boolean;
  OwnerDocuments: OwnerDocumentSearchResponseDto | null;
  OwnerDocumentsDataPages: Array<OwnerDocumentsDataPage>;
  isFetchingOwnerDocumentsFailed: Boolean;
  isFetchingOwnerDocuments: Boolean;
  isFetchingOwnerDocumentsSuccess: Boolean;
  errorMessageFetchingProperties: ErrorType;
  errorMessageFetchingDocuments: ErrorType;
};

const getInitialState = () => {
  return {
    Properties: [],
    isFetchingPropertiesFailed: false,
    isFetchingProperties: false,
    isFetchingPropertiesSuccess: false,
    OwnerDocuments: null,
    OwnerDocumentsDataPages: [],
    isFetchingOwnerDocumentsFailed: false,
    isFetchingOwnerDocuments: false,
    isFetchingOwnerDocumentsSuccess: false,
    errorMessageFetchingProperties: {} as ErrorType,
    errorMessageFetchingDocuments: {} as ErrorType,
  } as DocumentsState;
};

const documentsSlice = createSlice({
  name: 'documents',
  initialState: getInitialState(),
  reducers: {
    getOwnerProperties(state, action) {
      state.errorMessageFetchingProperties = {} as ErrorType;
      state.isFetchingPropertiesFailed = false;
      state.isFetchingProperties = true;
    },
    setOwnerProperties(state, action) {
      const propertiesData = {
        Properties: action.payload,
        isFetchingProperties: false,
        isFetchingPropertiesFailed: false,
        isFetchingPropertiesSuccess: true,
      };
      return { ...state, ...propertiesData };
    },
    getOwnerPropertiesFailed(state, action) {
      state.isFetchingPropertiesFailed = true;
      state.isFetchingProperties = false;
      state.isFetchingPropertiesSuccess = true;
      state.errorMessageFetchingProperties = action.payload;
    },
    getOwnerDocuments(state, action) {
      state.errorMessageFetchingDocuments = {} as ErrorType;
      state.isFetchingOwnerDocumentsFailed = false;
      state.isFetchingOwnerDocumentsSuccess = false;
      state.isFetchingOwnerDocuments = true;
    },
    setOwnerDocuments(state, action) {
      const _payload = action.payload;
      let currentDocumentPages = [...state.OwnerDocumentsDataPages];
      if (_payload.StartIndex === 0) currentDocumentPages = [];

      const whatPageResultsIsThis = Math.ceil(_payload.StartIndex / _payload.RangeSize);
      currentDocumentPages[whatPageResultsIsThis] = {
        Rows: _payload.Rows,
      };

      state.OwnerDocuments = action.payload;
      state.OwnerDocumentsDataPages = currentDocumentPages;
      state.isFetchingOwnerDocuments = false;
      state.isFetchingOwnerDocumentsFailed = false;
      state.isFetchingOwnerDocumentsSuccess = true;
    },
    getOwnerDocumentsFailed(state, action) {
      state.isFetchingOwnerDocumentsFailed = true;
      state.isFetchingOwnerDocuments = false;
      state.isFetchingOwnerDocumentsSuccess = false;
      state.errorMessageFetchingDocuments = action.payload;
    },
    getResetDocumentsState(state) {
      state = getInitialState();
      return { ...state };
    },
  },
});

export const { getOwnerProperties, setOwnerProperties, getOwnerDocuments, setOwnerDocuments, getOwnerPropertiesFailed, getOwnerDocumentsFailed } = documentsSlice.actions;

export default documentsSlice.reducer;
export const selectOwnerDocumentsState = (state: RootState) => state.ownerDocumentModuleState;
export const selectOwnerDocumentsDataPages = (state: RootState) => state.ownerDocumentModuleState.OwnerDocumentsDataPages;
export const selectOwnerDocuments = (state: RootState) => state.ownerDocumentModuleState.OwnerDocuments;
